{
    "AppBar.home": "Home",
    "AppBar.policies": "Policies",
    "AppBar.claims": "Claims",
    "AppBar.account": "My Account",
    "AppBar.logout": "Log Out"
}
